import { Injectable, Inject } from "@angular/core";
import { Observable, throwError, of } from "rxjs";
import 'rxjs/add/operator/map';
import 'rxjs/operator';
import 'rxjs/add/operator/catch';
import { HttpClient } from "@angular/common/http";
import { IFormSignature } from "../Models/Forms/IFormSignature";
import { BaseService } from './BaseService';

@Injectable()
export class FormSignatureService extends BaseService {

  _baseUrl: string = "";

  constructor(protected _http: HttpClient, @Inject('BASE_URL') baseUrl: string) {
    super(_http);
    this._baseUrl = baseUrl;
  }

  getFormSignature(id: number) {
    return this._http.get(this._baseUrl + "api/FormSignature/" + id)
      .map((response: IFormSignature) => response as IFormSignature)
      .catch(this.errorHandler);
  }

  insertUpdateFormSignature(formSignatureDetails: IFormSignature) {
    return this._http.post(this._baseUrl + 'api/FormSignature', formSignatureDetails)
      .map((response: IFormSignature) => response as IFormSignature)
      .catch(this.errorHandler);
  }

  deleteSignaturen(id) {
    return this._http.delete(this._baseUrl + "api/FormSignature" + id)
      .map((response: IFormSignature) => response as IFormSignature)
      .catch(this.errorHandler)
  }

  errorHandler(error: Response) {
    console.log(error);
    return Observable.throw(error);
  }

}


